import adminRequest from 'utils/adminRequest'

export const suggestParameters = (body) =>
  adminRequest.post('/ai-interview/suggest-parameters', body)

export const saveDefinition = (body) =>
  adminRequest.post('/ai-interview/definition', body)

export const getDefinition = (configId) =>
  adminRequest.get(`/ai-interview/definition/${configId}`)

export const assignToCandidates = (configId, emails) =>
  adminRequest.post('/ai-interview/assign', { configId, emails })

// Reports come from student-node via its own axios. Reuse adminRequest with
// an absolute URL override since student-node exposes the report endpoint.
export const getReport = (sessionId) => {
  const studentBase = process.env.STUDENT_API_URL || ''
  if (studentBase) {
    return adminRequest.get(`${studentBase}/ai-interview/report/${sessionId}`)
  }
  return adminRequest.get(`/ai-interview/report/${sessionId}`)
}

// Admin-side: look up the latest AI Interview report by assessmentAssignedId
// (so the student detail modal doesn't need to know the sessionId).
export const getReportByAssignment = (assessmentAssignedId) =>
  adminRequest.get(`/ai-interview/report-by-assignment/${assessmentAssignedId}`)
